var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('dataplat-search',{on:{"submit":_vm.handleSubmit}}),_c('dataplat-content',{attrs:{"current":_vm.searchForm.page,"list":_vm.tableList,"total":_vm.total,"type":"notice"},on:{"changePage":_vm.handleChangePage,"changePageSize":_vm.handleChangePageSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }